export default {
    'search-type': { // 全文搜索类型
        0: '全部',
        1: '课程',
        2: '专题',
        // 3: '慕课',
        4: '培训班',
        5: '考试',
        6: '调研',
        7: '直播',
        // 8: '问题',
        // 9: '文章',
        8: '纷享内容',
        // 9: '专家',
        // 10: '话题',
        // 11: '知识',
        // 12: '赛事活动'
        // 9: '纷享内容',
        10: '专家',
        11: '话题',
        12: '知识',
        13: '赛事活动'
    },
    'often-search-type': [ // 常用的全文搜索类型
        { key: 1, value: '课程' },
        { key: 2, value: '专题' },
        { key: 8, value: '培训班' },
        { key: 6, value: '考试' },
        { key: 7, value: '调研' },
        { key: 3, value: '直播' },
    ],
    'sometimes-search-type': [ // 较少用的全文搜索类型
        { key: 4, value: '知识' },
        { key: 9, value: '纷享' },
        { key: 10, value: '专家' },
        { key: 11, value: '话题' },
        { key: 5, value: '赛事' },
        // { key: 12, value: '商品' },
    ],
};

